/** @format */

import { DynamicTemplateLoader } from '@shared/data-access/services';
import { ViewContainerRef } from '@angular/core';

/**
 * When adding a new dynamically loaded component there are a few steps to note.
 * These steps are all necessary to the functionality of the app. Please note them each time you create a new component.
 * 1. Add new binding function, matching the structure below. The list of ids should match the normalized name of the content type as seen in the homR response.
 * 2. Each component module should have a resolveComponentFactory function, see story.module.ts for an example
 * 3. Each component and it's module should be included in their respective lists in the components/index.ts file
 */

interface IBindingFunction {
	ids: string[];
	loader: (
		dtlService: DynamicTemplateLoader,
		data: any,
		elemRef: ViewContainerRef,
		addlData: any
	) => void;
}
/* istanbul ignore next */
const bindingFunctions: IBindingFunction[] = [
	{
		/// Vertical Feature Spot
		ids: ['Image Banner'],
		loader: async (
			dtlService: DynamicTemplateLoader,
			data: any,
			elemRef: ViewContainerRef,
			addlData: any
		) => {
			const { HomrBannerComponent } = await import('@shared/homr/components');
			dtlService.loadComponent(data[0], elemRef, addlData, HomrBannerComponent);
		}
	},
	{
		/// Homr Banner Component
		ids: ['hero_v2'],
		loader: async (
			dtlService: DynamicTemplateLoader,
			data: any,
			elemRef: ViewContainerRef,
			addlData: any
		) => {
			const { HomrBannerContentComponent } = await import('../homr-banner-content');
			dtlService.loadComponent(data[0], elemRef, addlData, HomrBannerContentComponent);
		}
	}
];

export const ComponentBindings = () => {
	const result = {};

	bindingFunctions.forEach((bf) => {
		bf.ids.forEach((component) => {
			result[component] = bf.loader;
		});
	});

	return result;
};
